import React from "react";
import { 
  StyledCard, 
  StyledCol,
  StyledTypographyHeader,
  StyledTypographyDesc
} from "./CountDown.style";
// import { MarketplaceThemeProvider } from '../../../theme/MarketplaceTheme';
import Typography from "component/commonComponents/Typography";
import moment from 'moment';

interface ICountDown {
  startDate: number;
  locale: any;
  isOffboarding?: boolean;
  isLastAccess?: boolean;
};

const CountDown = (props: ICountDown) => {
  const { startDate, locale, isOffboarding = false, isLastAccess = false} = props;
  const now = moment(new Date()).format('YYYY-MM-DD').toString();
  const formatStartDate = moment(startDate).format('YYYY-MM-DD').toString();
  const reminderDays = moment(formatStartDate).diff(now,'days');

  return (
    <>
      {!isOffboarding && <Typography marginBottom="12px" fontWeight={600} fontSize="12px">{locale?.countdownMsg}</Typography>}
      <StyledCard isOffboarding={isOffboarding}>
        <StyledCol>
          <StyledTypographyHeader>
            {reminderDays >= 1? reminderDays : 0}  {reminderDays > 1? locale?.days: locale?.day}
              <StyledTypographyDesc>
                {isOffboarding && (!isLastAccess ? locale?.tolastworking : locale?.tolastaccess)}
              </StyledTypographyDesc>
          </StyledTypographyHeader>                
        </StyledCol>
      </StyledCard>
    </>
  )
};

export default CountDown;